module.exports = __webpack_public_path__ + "dummyImage.png?b45e02bc97292f9df392db690d792a93";